// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","gradient1":"App_gradient1__Tcl-S","gradient2":"App_gradient2__fYrcJ","gradient3":"App_gradient3__DXCDy","gradient4":"App_gradient4__v1Wxj"};